import { render, staticRenderFns } from "./NewDocumentModal.vue?vue&type=template&id=4a6aa574&scoped=true"
import script from "./NewDocumentModal.vue?vue&type=script&lang=js"
export * from "./NewDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./NewDocumentModal.vue?vue&type=style&index=0&id=4a6aa574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6aa574",
  null
  
)

export default component.exports